import { render, staticRenderFns } from "./MallHotelOrder.vue?vue&type=template&id=d7113ad2&scoped=true"
import script from "./MallHotelOrder.vue?vue&type=script&lang=js"
export * from "./MallHotelOrder.vue?vue&type=script&lang=js"
import style0 from "./MallHotelOrder.vue?vue&type=style&index=0&id=d7113ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7113ad2",
  null
  
)

export default component.exports